import type { ResolvedClinicService } from "@/lib/cms"

/**
 * Blood add-ons that need a draw before 10 am: cortisol peaks in the morning
 * and the hormone panels are read against morning reference ranges. A clinic
 * listing any of them shows a morning-slot note on its location page and in
 * the page's markdown mirror (AHD-13117). Keyed by the product's route, which
 * is the same in every locale (the CMS `products.path`).
 */
const MORNING_DRAW_PATHS = new Set([
  "/tests/cortisol-blood-test",
  "/tests/hormone-blood-test-men",
  "/tests/hormone-blood-test-women",
])

export function needsMorningDraw(services: ResolvedClinicService[]): boolean {
  return services.some(
    (service) => service.path !== null && MORNING_DRAW_PATHS.has(service.path)
  )
}
